import axios from 'axios'

export const byLocation = (lat, lng) =>
    axios.get(`events/list_events/0/20/0?lat=${lat}&lng=${lng}`)
    
export const filter = (filter, limit = 20) =>
    axios.get(`events/list_events/0/${limit}/0?filter=${filter}`)

export const loadExtras = (token, allow_extra_sales = 0) =>
    axios.get(`events/extras/${token}/?allow_extra_sales=${allow_extra_sales}`)

export const checkoutExtras = (form) =>
    axios.post(`extra_sales/event`, form)


// WEBPACK FOOTER //
// ./src/utils/events.js